import { APICore } from "./apiCore";

const api = new APICore();

function ApiGetAllTagihan(params: any): any {
  const baseUrl = "/api/admin/get_company_payment";
  return api.get(`${baseUrl}`, params);
}
function ApiPostTagihan(params: any): any {
  const baseUrl = "/api/admin/create_company_payment";
  return api.create(`${baseUrl}`, params);
}
function ApiEditTagihan(params: any, id: any): any {
  const baseUrl = "/api/admin/update_company_payment/" + id;
  return api.update(`${baseUrl}`, params);
}
function ApiCekOUTagihan(params: any): any {
  const baseUrl = "/api/admin/checkout_payment";
  return api.create(`${baseUrl}`, params);
}
function ApiPrintInvoice(params: any, invoice: any): any {
  const baseUrl = "/api/admin/invoice/pdf/" + invoice;
  return api.getFile(`${baseUrl}`, params);
}

export {
  ApiGetAllTagihan,
  ApiPostTagihan,
  ApiCekOUTagihan,
  ApiPrintInvoice,
  ApiEditTagihan,
};
